import { Component } from '@angular/core';
import {
  ClientMinuteRequestDTO,
  CompanyDebtorMinuteRequestResolutionDTO,
  InvoiceOperationMinuteDTO,
  MinuteRequestDetailRealTimeDTO,
  MinuteRequestSnapshotDTO,
  OwnersMinuteRequest,
} from '../../minutes/interface/minute-detail';
import { MinuteRequestKpiDTO } from '../../minutes/interface/minute-request-kpis.interface';
import { ActivatedRoute, Params } from '@angular/router';
import { RealTimeMinuteService } from '../../minutes/service/real-time-minute.service';
import html2pdf from 'html2pdf.js';
import { MinuteRequestService } from '../../minutes/service/minute-request.service';
import { LegacyScoring } from '../../../interface/legacy-scoring';
import { Location } from '@angular/common';
import { faCircleXmark, IconDefinition, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/enviroments';

@Component({
  selector: 'app-pdf',
  templateUrl: './pdf.component.html',
  styleUrls: ['./pdf.component.scss'],
})
export class PdfComponent {
  public iconAproved: IconDefinition = faCheckCircle;
  public iconReject: IconDefinition = faCircleXmark;
  public originalFactoringOperation: InvoiceOperationMinuteDTO;
  public resolutionName: string;
  public minuteRequestRealTime: MinuteRequestDetailRealTimeDTO | null = null;
  public minuteDebtorResolutions: Array<CompanyDebtorMinuteRequestResolutionDTO>;
  public legacyDataUser: LegacyScoring | null = null;
  public minuteRequestKpi: MinuteRequestKpiDTO;
  public minuteRequestClient!: ClientMinuteRequestDTO;
  public minuteOwnersRequest: OwnersMinuteRequest[] | undefined;
  public minuteSnapshot: MinuteRequestSnapshotDTO;
  public minuteDebtors: CompanyDebtorMinuteRequestResolutionDTO[];
  public operations: any;
  public nminute: number;
  public myAngularxQrCode: string = "Vacio";

  constructor(
    private _location: Location,
    private router: ActivatedRoute,
    private minuteRequestService: MinuteRequestService,
    public realTimeMinute: RealTimeMinuteService
  ) {
    this.minuteDebtorResolutions = new Array<CompanyDebtorMinuteRequestResolutionDTO>();
    this.minuteDebtors = new Array<CompanyDebtorMinuteRequestResolutionDTO>();
    this.minuteRequestKpi = {
      debtorsLast12Months: [],
      debtorsTop10: [],
      debtorsLast24Months: [],
      factoringByCesionarios: [],
    };
  }

  ngOnInit(): void {

    Swal.fire({
      title: 'Generando PDF',
      timer: 5000,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();

        this.router.queryParams.subscribe((params: Params) => {
          const id = params['id'] | 0;
          this.nminute = id;
          this.myAngularxQrCode = environment.urlRoot + '/dashboards/minuteQR?id=' + id;
          this.getRealTimeInfoMinuteRequest(id);
          // this.getMinuteRequestKpi(id);
          setTimeout(() => {
            this.createPdf();
            this.volver();
          }, 3500);
        });

      },
    });

  }

  private setMinuteFactoringOperation(
    originalFactoringOperation: InvoiceOperationMinuteDTO
  ) {
    this.originalFactoringOperation = originalFactoringOperation;
  }

  public getRealTimeInfoMinuteRequest(minuteRequestId: number) {
    this.realTimeMinute.startConnection(minuteRequestId);
    this.realTimeMinute.receivedMinuteDetai$.subscribe({
      next: (response) => {
        this.setMinuteRequestData(response);
      },
    });

    this.realTimeMinute.receivedMinuteDebtorResolutions$.subscribe({
      next: (debtorResolutions) => {
        this.minuteDebtors = debtorResolutions;
        this.minuteDebtorResolutions = debtorResolutions;
      },
    });
  }

  public obtenerLegacyData(r: string) {
    const rut = r.replaceAll('.', '');
    this.minuteRequestService.getLegacyData(rut).subscribe({
      next: (response) => {
        console.log("Consulta exitosa a API LegacyData");
        this.legacyDataUser = response;
      },
      error: (response) => {
        console.log("Error con API LegacyData:" + response);
      },
    });
  }

  public setMinuteRequestData(realTimeMinute?: MinuteRequestDetailRealTimeDTO) {
    this.resolutionName = realTimeMinute?.finalResolutionName;
    this.minuteRequestRealTime = realTimeMinute;

    const { operations } = realTimeMinute;
    this.operations = operations;

    const {
      snapshot: { minuteRequestKpi, client, originalOperation },
    } = realTimeMinute;
    this.minuteSnapshot = realTimeMinute.snapshot;
    this.setKpis(minuteRequestKpi);
    this.setMinuteClient(client);
    this.setMinuteFactoringOperation(originalOperation);
    // this.loadingMinute = false;
  }

  private setKpis(minuteKpi: MinuteRequestKpiDTO) {
    this.minuteRequestKpi = minuteKpi;
  }

  private setMinuteClient(minuteClient: ClientMinuteRequestDTO) {
    this.minuteRequestClient = minuteClient;
    this.minuteOwnersRequest = minuteClient.owners;
  }

  public volver() {
    this._location.back();
  }

  options = {
    margintosd: 12,
    margin: [20,24,20,24],
    filename: 'minuta.pdf',
    image: {
      type: 'jpeg',
      quality: '0.95',
    },
    pagebreak: { mode: 'avoid-all', after: '#finPage1, #finPage2, #finPage3' },

    html2canvas: {
      scale: 2,
      windowWidth: window.innerWidth, // Ancho total de la ventana
      windowHeight: window.innerHeight,
    },

    jsPDF: {
      unit: 'pt',
      format: 'letter',
      orientation: 'portrait',
    },
  };

  /*createPdf(): void {
    var element = document.getElementById('htmlData');
    element.style.width = '100%';
    html2pdf()
      .from(element)
      .set(this.options)
      .toPdf()
      .get('pdf')
      .then(function (pdf) {
        //pdf.addPage();
      })
      .from(element)
      .set(this.options)
      .save("Minute N°"+ this.nminute)
      .finally(function () {
        // Mostrar las secciones ocultas después de generar el PDF
        document.querySelectorAll('.desc_line').forEach(function (el: any) {
          el.style.display = 'flex';          
        });
        document.querySelectorAll('.page2').forEach(function (el: any) {
          el.style.pageBreakBefore ='always'
        });
      });
  }*/

  createPdf(): void {
    const element = document.getElementById('htmlData');
    if (!element) {
      console.error('Element with id "htmlData" not found!');
      return;
    }

    element.style.width = '100%';

    html2pdf()
      .from(element)
      .set(this.options)
      .toPdf()
      .get('pdf')
      .then((pdf) => {
        // You can add extra pages if needed
        // pdf.addPage();
      })
      .set(this.options)
      .save("Minute N°" + this.nminute)
      .finally(() => {
        // Mostrar las secciones ocultas después de generar el PDF
        document.querySelectorAll('.desc_line').forEach((el: HTMLElement) => {
          el.style.display = 'flex';
        });
        document.querySelectorAll('.page2').forEach((el: HTMLElement) => {
          el.style.pageBreakBefore = 'always';
        });
      });
  }

}
